import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage, {FETCHPRIORITY} from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import PlaySolid from '@adv-mt/mt-svg-icons/lib/PlaySolid'

import {BASE_CLASS, THUMBNAIL_CLASS, THUMBNAIL_IMAGE_CLASS} from '../../config.js'

const GalleryBasicThumbnail = ({firstImage, image, isSelected, onClickThumbnail}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const {alt, src} = image.isVideo ? firstImage : image

  const thumbnailImageClass = cx(THUMBNAIL_IMAGE_CLASS, isSelected && 'is-selected')

  const iconSize = isMobile ? ATOM_ICON_SIZES.extraSmall : ATOM_ICON_SIZES.medium

  return (
    <div className={THUMBNAIL_CLASS} onClick={onClickThumbnail}>
      {Boolean(image.isVideo) && (
        <div className={`${BASE_CLASS}-videoControl`}>
          <div className={`${BASE_CLASS}-videoControlPlay ${BASE_CLASS}-videoControlPlay--small`}>
            <PlaySolid size={iconSize} />
          </div>
        </div>
      )}
      <AtomImage alt={alt} className={thumbnailImageClass} fetchpriority={FETCHPRIORITY.HIGH} src={src} />
    </div>
  )
}

GalleryBasicThumbnail.displayName = 'GalleryBasicThumbnail'
GalleryBasicThumbnail.propTypes = {
  firstImage: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    isVideo: PropTypes.bool
  }),
  isSelected: PropTypes.bool,
  onClickThumbnail: PropTypes.func.isRequired
}

export default GalleryBasicThumbnail
